import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {MonkeysGoldBonusGameMultiplierView} from "./MonkeysGoldBonusGameMultiplierView";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {MonkeysGoldParsedInitData} from "../../server/data/MonkeysGoldParsedInitData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

/**
 * Created by Jerker Nord on 2020-06-05.
 */

export class MonkeysGoldBonusGameMultiplierController extends WinPresentationController {

    private _view:MonkeysGoldBonusGameMultiplierView;
    private _fsMultiplierBefore:number;
    private _fsMultiplierAfter:number;
    private _fsMultiplierIncrease:number;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "MonkeysGoldBonusGameMultiplierController", skippable : false});
        this._view = MonkeysGoldGameModuleConfig.monkeysGoldBonusGameMultiplierView = new MonkeysGoldBonusGameMultiplierView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:MonkeysGoldParsedInitData):void {
        if(data.isRestoreState == true) {
            if(data.mode == GameMode.FREESPIN || data.mode == GameMode.FREESPIN_AVALANCHE || ((data.mode == GameMode.NORMAL || data.mode == GameMode.NORMAL_AVALANCHE) && data.nextMode == GameMode.FREESPIN)) {
                this._view.isRestore = true;
                this._view.enableMultplier();
                if((data.mode == GameMode.NORMAL || data.mode == GameMode.NORMAL_AVALANCHE) && data.nextMode == GameMode.FREESPIN) {
                    this._view.setMultiplierValue(data.fsMultiplierIncrease, data.fsMultiplierIncrease, true);
                } else {
                    this._view.setMultiplierValue(data.fsMultiplier, data.fsMultiplierIncrease, true);
                }
            }
        }
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._fsMultiplierBefore = data.fsMultiplierBefore;
        this._fsMultiplierAfter = data.fsMultiplierAfter;
        this._fsMultiplierIncrease = data.fsMultiplierIncrease;
    }

    protected hasWin():boolean {
        if(this._gameData!.mode == GameMode.FREESPIN_AVALANCHE && this._gameData!.nextMode == GameMode.FREESPIN) {
            if(this._fsMultiplierAfter > 1 && (this._fsMultiplierAfter == this._fsMultiplierBefore)) {
                MonkeysGoldGameModuleConfig.monkeysGoldRowLockWPController.cleanUp();
                MonkeysGoldGameModuleConfig.monkeysGoldRowLockView.resetAllAnimations();
            }
        }
        return false;
    }

    protected startWinPresentation():void {

        this.finish();
    }

    protected stopWinPresentation(isAborted:boolean):void {

    }
}